export {
	type ContentHeaderTemplateDataSubscription,
	watchContentHeaderTemplateData,
} from '../src/watchContentHeaderTemplateData.ts';
